export default __webpack_public_path__ + "static/media/INEX.3acde751.png";